import { render, staticRenderFns } from "./Screensaver.vue?vue&type=template&id=7745c005&scoped=true"
import script from "./Screensaver.vue?vue&type=script&lang=js"
export * from "./Screensaver.vue?vue&type=script&lang=js"
import style0 from "./Screensaver.vue?vue&type=style&index=0&id=7745c005&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7745c005",
  null
  
)

export default component.exports